const toggleCopyright = () => {
    const copyright = document.querySelector(".copyright")
    if (copyright) {
        copyright.addEventListener("click", () => {
            copyright.classList.toggle("active")
        })
    }
}

export default toggleCopyright
